import { createAction } from 'redux-act';

export const fetchEventDetail = createAction<any>('get Event detail');

export const setEventDetail = createAction<any>('set Event detail');